<template>
    <div>
        <h1
            class="py-0 my-0"
        >
            Content Type: Article
        </h1>
    </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped></style>
